import gql from 'graphql-tag';

export default gql`
  mutation deleteOwnUnsubmittedInteraction($id: UUID!) {
    deleteOwnUnsubmittedInteraction(id: $id)
  }
`;
